let load = require('./helpers/browser/esm-js-loader');
module.exports = Promise.all([load("3yAl4"), load("76n7a"), load("l253H"), load("axvph")]).then(() => parcelRequire('kDfjQ'));